module.exports = __webpack_public_path__ + "media/assets/images/blog/app_three-efc584dc87f05d055841b48ef4295aee.jpg";